import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {ContentWrapper, H2Styled, H3Styled, ReviewLinksStyled} from './ReviewsPage.style';
import {TRIP_ADVISOR_URI} from '../../constants/constant';
import {Loading} from '../../components/Loading/Loading';
import {injectScriptTag} from '../../helpers/loadScript.helper';
import {sanitizeUrl} from '../../helpers/string.helper';

class ReviewsPageContent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      errorCode: null
    };
  }

  componentWillMount() {
    if (!this.props.thirdPartyServices || !this.props.thirdPartyServices.tripAdvisorId) {
      return;
    }

    const {tripAdvisorId, showTripAdvisorRating} = this.props.thirdPartyServices;
    const url = `${TRIP_ADVISOR_URI}&locationId=${tripAdvisorId}&popIdx=${showTripAdvisorRating}`;

    injectScriptTag(url)
      .then(() => {
        this.setState({loading: false});
        if (window && window.taValidate) {
          window.taValidate();
        }
      })
      .catch(() => this.setState({
        errorCode: 'reviews.tripAdvisorError',
        loading: false
      }));
  }

  render() {
    const tripAdvisorId = this.props.thirdPartyServices && this.props.thirdPartyServices.tripAdvisorId;
    const socialLinks = this.props.thirdPartyServices && this.props.thirdPartyServices.socialLinks;
    const renderError = this.state.errorCode && <FormattedMessage id={this.state.errorCode} />;
    const renderLoading = this.state.loading && <Loading />;

    const renderTripAdvisorWidget = tripAdvisorId &&
      <div>
        <H3Styled><FormattedMessage id="reviews.tripAdvisor" /></H3Styled>
        {renderError}
        {renderLoading}
        <div
          id="TA_selfserveprop870"
          className="TA_selfserveprop"
        >
          <ul
            id="DkroajoC9r"
            className="TA_links YSnaCT13JX4G"
          />
        </div>
      </div>;

    const renderSocialLinks = socialLinks && Object.keys(socialLinks).length > 0 &&
      <ReviewLinksStyled>
        {
          Object.keys(socialLinks).map(key =>
            <li key={key}>
              <a
                href={sanitizeUrl(socialLinks[key])}
                target="_blank"
              >{key}</a>
            </li>
          )
        }
      </ReviewLinksStyled>;

    return (
      <div>
        <ContentWrapper data-rw="contact-page--content">
          <H2Styled><FormattedMessage id="reviews.title" /></H2Styled>
          {renderSocialLinks}
          {renderTripAdvisorWidget}
        </ContentWrapper>
      </div>
    );
  }
}

ReviewsPageContent.propTypes = {
  thirdPartyServices: PropTypes.object
};

export default ReviewsPageContent;



// WEBPACK FOOTER //
// ./containers/ReviewsPage/ReviewsPageContent.js